<div class="contact-support-container">
  <p class="font-bold">Please click on the following button to contact support</p>
  <p>
    <button type="button" pButton class="p-button-link p-0 cursor-pointer text-blue-600 hover:underline" lfxOpenIntercom>Open Support Chat</button>
  </p>
  <p class="font-bold">Issue Details</p>
  <p>Please add the following information in your ticket description to allow our support team to assist you better</p>
  <div class="stack-trace">
    <pre><code>{{ errorStack | json }}</code></pre>
  </div>
  <div class="flex justify-start">
    <button pButton class="p-button-primary flex" [cdkCopyToClipboard]="errorStack | json" appendTo="body" (click)="onClickCopy()">
      {{ copyText }}
    </button>
  </div>
</div>
